// extracted by mini-css-extract-plugin
module.exports = {"BeeSpinner":"beeSpinnerLoading_BeeSpinner__dX1Jw","progressAnimation":"beeSpinnerLoading_progressAnimation__24hb3"};